import { getTranslatedText } from "../../../../utils/getTranslatedText";
import { useGetTranslatedText } from "../../lms/queries";
import styles from "./styles.module.scss";

const CreScoreHighlightCard = ({
  score,
  message,
  isEligible,
  data
}) => {
    const languageId = localStorage.getItem("l_id") || 1;
    
    const { data: translatedTextResponse } = useGetTranslatedText(languageId);
    
    const { data: translatedText = [] } = translatedTextResponse || {};

  return (
  <>
    <div className={styles.card}>
      {/* Score */}
      <h1 className={styles.score}>{score}</h1>

      {/* Message */}
      <p className={styles.message}>{message}</p>

      {/* Eligibility */}
      <div
        className={`${styles.eligibility} ${
          isEligible ? styles.success : styles.error
        }`}
      >
        <span className={styles.icon}>✔</span>
        {isEligible
          ? 
          getTranslatedText(
              translatedText,
              "cre_score_note",
              "You are eligible to earn CRE Points"
            ) 
          : getTranslatedText(
              translatedText,
              "cre_score_not_note",
             "You are not eligible for CRE Points"
            )}
      </div>
    </div>
    <div className={styles.container}>
      <p className={styles.title}>
        {
          getTranslatedText(
              translatedText,
              "cre_programme_weightage_distribution",
             "CRE programme weightage distribution"
            )
        }
      </p>

      <div className={styles.row}>
        {data?.map((item, index) => (
          <div key={index} className={styles.item}>
            <div className={styles.valueRow}>
              <span className={styles.bar} />
              <span className={styles.value}>{item.value}%</span>
            </div>

            <p className={styles.label}>{item.label}</p>

            {index !== data.length - 1 && (
              <span className={styles.plus}>+</span>
            )}
          </div>
        ))}
      </div>
    </div>
  </>
  );
};

export default CreScoreHighlightCard;